import styled from '@emotion/styled';

export default styled.div`
    padding: 5em 0 0;
`;